
//define by storage because store load after router
const DEFAULT_VESION = 'v2'
const versionLocalStorage = localStorage.getItem('version') || DEFAULT_VESION

function validateVersionFunc (val) {
  return ['v1','v2'].includes(val) ? val : DEFAULT_VESION
}
//prohibit change value in localstorage by user 


export const validateVersion = validateVersionFunc
export const IS_NEW_VERSION = validateVersionFunc(versionLocalStorage) === DEFAULT_VESION